import React from "react";
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBed } from "@fortawesome/free-solid-svg-icons";

function Rooms({ roomsData, roomSetter }) {
    const { t } = useTranslation();
    
    return (
        <section className="rooms sec-width" id="rooms">
            <div className="title">
                <h2>{t('menu.rooms')}</h2>
                <p className="rooms-subtitle">{t('rooms.subtitle')}</p>
            </div>
            <p>{t('footer.taxInfo')}</p>

            <div className="rooms-container">
                {roomsData.map((room, index) => (
                    <article className="room" key={index}>
                        <div className="room-image">
                            <img src={room.image} alt={t(room.titleKey)} />
                        </div>
                        <div className="room-text">
                            <h3>{t(room.titleKey)}</h3>
                            <div className="bed-size-info">
                                <FontAwesomeIcon icon={faBed} className="bed-icon" />
                                <span className="bed-size-text">{t(room.bedSizeKey)}</span>
                            </div>
                            <ul>
                                {room.features.map((feature, index) => (
                                    <li key={index}>
                                        <i className="fas fa-arrow-alt-circle-right"></i>
                                        {feature}
                                    </li>
                                ))}
                            </ul>
                            <p className="rate">
                                <span>{room.rate}€/</span> {t('rooms.perNight', 'Par nuit')}
                            </p>
                            <a href="#book" className="btn" onClick={() => {roomSetter(t(room.titleKey))}}>{t('header.reserveButton')}</a>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}

export default Rooms;
